const ConfigurationV2TypePolicy = {
  ConfigurationV2: {
    keyFields: object => object.uidV2,
  },
};

export default ConfigurationV2TypePolicy;
